import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import {
    Collapse,
    Row,
    Col,
    Card,
    Statistic,
    Switch,
    Spin,
    Alert,
    Modal,
    Button,
    Checkbox
} from 'antd';
import QQPlotChart from './QQPlotChart';

const RobustRegressionMultiChart = (props) => {
    const { Panel } = Collapse;

    let regressionData = props.getAnalysisRes.robust_regression;

    let regressionOptions = {
        title: {
            // text: 'Residuals Plot'
            text: 'Standardized Residuals'
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },
        // xAxis: {
        //     min: -0.5,
        //     max: 5.5
        // },
        credits: {
            enabled: false
        },
        yAxis: {
            title: {
                text: 'Standardized Residuals'
            }
        },
        colors: ['#60091D', '#407CB1'],
        series: [
            {
                type: 'spline',
                name: 'Loess',
                data: regressionData.loess,
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        lineWidth: 0
                    }
                },
                enableMouseTracking: false
            },
            {
                type: 'scatter',
                name: 'Fitted',
                data: regressionData.scatter_res,
                marker: {
                    radius: 4
                }
            }
        ],
        tooltip: {
            useHTML: true,
            shape: 'square',
            shared: false,
            borderRadius: 0,
            borderWidth: 0,
            shadow: false,
            enabled: true,
            backgroundColor: 'none',
            formatter: function () {
                var string = `<div class="tooltipContainer">${this.x.toFixed(
                    4
                )}:${this.y.toFixed(4)}</div>`;
                return string;
            }
        }
    };

    let regScatterplotOptions = {
        chart: {
            marginRight: 30,
            marginLeft: 77,
            marginTop: 20,
            renderTo: 'chart-container',
            zoomType: 'xy',
            height: 400
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },
        credits: {
            enabled: false
        },
        title: {
            text: undefined,
            style: { fontSize: '11px' }
        },
        subtitle: {
            text: undefined,
            style: { fontSize: '10px' }
        },
        xAxis: [
            {
                endOnTick: true,
                //tickInterval: 1,
                tickLength: 0,
                lineWidth: 0,
                labels: {
                    enabled: true,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '11px'
                    }
                },
                title: {
                    text: regressionData.x_display_name,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '14px'
                    }
                }
            }
        ],
        yAxis: [
            {
                // Primary yAxis
                //minorTickInterval: 'auto',
                labels: {
                    style: { fontSize: '11px' }
                },
                title: {
                    text: regressionData.y_display_name,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '14px'
                    }
                }
            }
        ],
        navigation: {
            buttonOptions: {
                align: 'right',
                backgroundColor: '#ffffff',
                borderColor: '#B0B0B0',
                borderRadius: 3,
                borderWidth: 1,
                enabled: true,
                height: 20,
                hoverBorderColor: '#909090',
                hoverSymbolFill: '#81A7CF',
                hoverSymbolStroke: '#4572A5',
                symbolFill: '#E0E0E0',
                symbolSize: 12,
                symbolStroke: '#A0A0A0',
                symbolStrokeWidth: 1,
                symbolX: 11.5,
                symbolY: 10.5,
                verticalAlign: 'top',
                width: 24,
                y: 10
            },
            menuStyle: {
                border: '1px solid #A0A0A0',
                background: '#FFFFFF'
            },
            menuItemStyle: {
                padding: '0 5px',
                background: 'NONE',
                color: '#303030'
            },
            menuItemHoverStyle: {
                background: '#4572A5',
                color: '#FFFFFF'
            }
        },
        tooltip: {
            useHTML: true,
            shape: 'square',
            shared: false,
            borderRadius: 0,
            borderWidth: 0,
            shadow: false,
            enabled: true,
            backgroundColor: 'none',
            formatter: function () {
                if (this.point.company_id) {
                    var string = `<div class="tooltipContainer">Company ID: ${this.point.company_id}<br>FY: ${this.point.fy}<br>${this.x}:${this.y}</div>`;
                } else {
                    var string = `<div class="tooltipContainer">${this.x.toFixed(
                        4
                    )}:${this.y.toFixed(4)}</div>`;
                }
                return string;
            }
        },
        plotOptions: {
            scatter: { marker: { radius: 2 } }
        },

        legend: {
            enabled: false,
            layout: 'vertical',
            align: 'left',
            x: 10,
            verticalAlign: 'top',
            y: 0,
            floating: true,
            backgroundColor: '#FFFFFF'
        },
        series: [
            {
                name: 'seriesOneName1',
                color: '#407CB1',
                type: 'scatter',
                yAxis: 0,
                // data: scatterDataIndex,
                data: regressionData.scatter,
                turboThreshold: 50000
            },

            {
                name: 'seriesTwoName1',
                type: 'spline',
                color: '#60091D',
                yAxis: 0,
                // data: scatter_data['chart']['fitted'],
                data: regressionData.scatter_line,
                marker: { enabled: false },
                turboThreshold: 50000
            }
        ]
    };

    let regRows = [];

    for (let i = 0; i < Object.keys(regressionData.reg_stat).length; i++) {
        regRows.push(Object.values(regressionData.reg_stat)[i]);
    }

    let newRegRows = regRows.map((item) => {
        let fixedValue = item.value;

        return (
            <Col
                span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
                style={{ marginTop: 10 }}
            >
                <Card>
                    <Statistic
                        key={item.display_name}
                        title={item.display_name}
                        value={fixedValue}
                    />
                </Card>
            </Col>
        );
    });

    let statRegTable = (
        <>
            <div>
                <Row className="statistics-row-box" gutter={16}>
                    {newRegRows}
                </Row>
            </div>
        </>
    );

    let newStatsRegRows2 = regRows.map((item) => {
        let fixedValue = item.value;
        return (
            <tr>
                <td className="title">{item.display_name}</td>
                <td className="value">{fixedValue}</td>
            </tr>
        );
    });

    let statRegTable2 = (
        <>
            <div key="12341">
                <div className="statistics-row-box">
                    <div className="table-box-fullproject-view">
                        <h3>Robust Regression Statistics</h3>
                        <table className="table-table">
                            <tbody>{newStatsRegRows2}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    let headers = [];
    let rows = [];

    for (let i = 0; i < Object.keys(regressionData.resid_stat).length; i++) {
        headers.push(
            Object.keys(regressionData.resid_stat)[i].charAt(0).toUpperCase() +
                Object.keys(regressionData.resid_stat)[i].slice(1)
        );
    }

    for (let j = 0; j < Object.keys(regressionData.resid_stat).length; j++) {
        rows.push(Object.values(regressionData.resid_stat)[j].toFixed(4));
    }

    let newHeaders = headers.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let newRows = rows.map((item) => {
        return <td key={item}>{item}</td>;
    });

    let table = (
        <>
            <div className="table-box-fullproject">
                <h3>Standardized Residuals</h3>
                <table className="table-regression first-row-bold">
                    <thead>
                        <tr>{newHeaders}</tr>
                    </thead>
                    <tbody>
                        <tr>{newRows}</tr>
                    </tbody>
                </table>
            </div>
        </>
    );

    let stdErrHeaders = ['', 'Coeff', 'Std Error', 't-Stat', 'Vif'];

    let newStdErrHeaders = stdErrHeaders.map((item) => {
        return <th key={item}>{item}</th>;
    });

    let dataRows = Object.values(regressionData.std_err);

    let tableRows = [];

    for (let i = 0; i < dataRows.length; i++) {
        let dr = dataRows[i];

        let coeff = dr.coeff;
        let std_err = dr.std_err;
        let t_stat = dr.t_stat;
        let vif = typeof dr.vif == 'string' ? '-' : dr.vif;

        tableRows.push(
            <tr>
                <td>{dr.display_name}</td>
                <td>{coeff}</td>
                <td>{std_err}</td>
                <td>{t_stat}</td>
                <td>{vif}</td>
            </tr>
        );
    }

    let titleFilterVariable = ''
    if(regressionData.filter_by_variable){
        titleFilterVariable = `[${regressionData.filter_by_variable}]`
    }

    let stdErrRows = [];

    let stdErrTable = (
        <>
            <div className="table-box-fullproject">
                <h3>Std Error</h3>
                <table className="table-regression">
                    <thead>
                        <tr>{newStdErrHeaders}</tr>
                    </thead>
                    <tbody>{tableRows}</tbody>
                </table>
            </div>
        </>
    );


    let fullStats = (
        <div ref={props.forwardedRefStatistics}>
            {statRegTable2}
            {table}
            {stdErrTable}
        </div>
    );
    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`Robust Regression ${titleFilterVariable}`}>
                    {/* Regression Chart */}
                    {regressionData.scatter && regressionData.scatter_line ? (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={regScatterplotOptions}
                            ref={props.forwardedRef}
                        />
                    ) : null}

                    {/* Regression Scatterplot Chart */}
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={regressionOptions}
                        ref={props.forwardedRefStdRes}
                    />

                    {/* Standardized Residuals QQ Plot */}
                    {regressionData.standardized_residuals_qq_plot && (
                        <QQPlotChart
                            getAnalysisRes={regressionData}
                            forwardedRefNormal={props.forwardedRefQQPlotNormal}
                            forwardedRefLognormal={props.forwardedRefQQPlotLognormal}
                            forwardedRefBurr12={props.forwardedRefQQPlotBurr12}
                        />
                    )}

                    {fullStats}
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(RobustRegressionMultiChart);
